import { Component } from "preact";
import { ObjectUtils } from "@green24/npm-javascript-utils";

class Route extends Component {
	render(props) {
		return props.children(ObjectUtils.withoutProperties(props, ["children", "path"]));
	}
}

export default Route;
